import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Heading, Pane } from 'evergreen-ui';
import { ReportContext } from './Report.Context';

export default function ReportsDefaultPage() {
  const { reset } = React.useContext(ReportContext);
  const navigate = useNavigate();

  const resetAndContinue = () => {
    reset();
    navigate('new');
  };

  return (
    <Pane
      display="flex"
      flex={1}
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <Heading size={700} marginTop={-100} marginBottom={16}>Выберите отчет слева для просмотра</Heading>
      <Button appearance="minimal" intent="none" height={40} onClick={resetAndContinue}>Создать отчет</Button>
    </Pane>
  );
}
